module.exports = __webpack_public_path__ + "img/5.f5cc5a99.jpg";